// extracted by mini-css-extract-plugin
export default {"error":"Error_error__iDy0I","slideIn":"Error_slideIn__+Iama","error-icon":"Error_error-icon__OeIFI","error-message":"Error_error-message__5NsER"};